import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, Icon } from '@node-space/ui-components'
import { AmplitudeEvent } from 'utils/amplitude/amplitudeEvents'
import { useRewardsSheetContext } from '../context/RewardsSheetProvider'
import { useRewardsTracking } from '../hooks/useRewardsTracking'
import { RewardsActionIds } from '../types'

interface RewardsHeaderActionsProps {
  showWithdrawButton?: boolean
  showDepositButton?: boolean
}

export const RewardsHeaderActions = ({
  showWithdrawButton,
  showDepositButton,
}: RewardsHeaderActionsProps) => {
  const { t } = useTranslation()
  const { handleSheetOpen } = useRewardsSheetContext()
  const { trackClick } = useRewardsTracking()

  const handleOpenDepositSheet = () => {
    trackClick(AmplitudeEvent.REWARDS_ALLOCATE_FUNDS_INITIATE)
    handleSheetOpen({
      actionId: RewardsActionIds.DEPOSIT,
      header: t('rewards.deposit.header'),
    })
  }

  const handleOpenWithdrawSheet = () => {
    trackClick(AmplitudeEvent.REWARDS_WITHDRAW_FUNDS_INITIATE)
    handleSheetOpen({
      actionId: RewardsActionIds.WITHDRAW,
      header: t('rewards.withdraw.header'),
    })
  }

  return (
    <Box flex gap={12}>
      {showWithdrawButton && (
        <Button
          variant="secondary"
          onClick={handleOpenWithdrawSheet}
          iconElement={<Icon name="Plus" />}
        >
          {t('rewards.withdrawFunds')}
        </Button>
      )}
      {showDepositButton && (
        <Button onClick={handleOpenDepositSheet} iconElement={<Icon name="Plus" />}>
          {t('rewards.allocateFunds')}
        </Button>
      )}
    </Box>
  )
}
